import { Component, inject, OnDestroy } from '@angular/core';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { takeUntil } from 'rxjs/operators';
import { BookingService } from '@beautyapp/core';
import { catchError, Subject, throwError } from 'rxjs';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { VisitAddFacade } from '@beautyapp/shared';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TextareaComponent } from '@beautyapp/form';

@Component({
  selector: 'beautyapp-booking-disable-reason',
  template: `
    <form [formGroup]="form">
      <beautyapp-textarea
        formControlName="disableReason"
        label="გაუქმების მიზეზი"
        placeholder="მიუთითეთ გაუქმების მიზეზი"
      ></beautyapp-textarea>
    </form>
    <div *nzModalFooter>
      <nz-space>
        <button *nzSpaceItem nz-button nzType="default" (click)="modal.close()">გაუქმება</button>
        <button *nzSpaceItem nz-button nzType="primary" nzDanger [nzLoading]="isLoading" (click)="deleteBooking()">
          წაშლა
        </button>
      </nz-space>
    </div>
  `,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TextareaComponent,
    NzModalModule,
    NzSpaceModule,
    NzButtonModule
  ]
})
export class BookingDisableReasonComponent implements OnDestroy {
  modal = inject(NzModalRef);
  private visitAddFacade = inject(VisitAddFacade);
  private bookingService = inject(BookingService);

  readonly data = inject(NZ_MODAL_DATA);

  get bookingId() {
    return this.data.bookingId;
  }

  isLoading = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    disableReason: new UntypedFormControl(null)
  });

  sub$ = new Subject();

  deleteBooking() {
    this.isLoading = true;
    this.visitAddFacade.loading.set(true);
    this.bookingService.delete(this.bookingId, this.form.value)
      .pipe(
        takeUntil(this.sub$),
        catchError((error) => {
          this.visitAddFacade.loading.set(false);
          this.isLoading = false;
          return throwError(() => error);
        })
      )
      .subscribe(() => {
        this.modal.triggerOk();
        this.visitAddFacade.loading.set(false);
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }
}